export default __webpack_public_path__ + "static/sticker-background-c7979d16e75b7720cfbd8011b8c3ce33.jpg";